import BookmarkedListings from '../../../components/screens/market/bookmarked-listings/BookmarkedListings';

const BookmarkedListingsContainer = () => {
  return <BookmarkedListings />;
};

export default BookmarkedListingsContainer;
